import { Form } from "antd";
import type { EvaluationAdviceFiledType } from "../type";
import { useMutation } from "@tanstack/react-query";
import { updatePerformanceEvaluationAdvice } from "@/apis/supplier";
import { UpdatePerformanceEvaluationAdviceSchema } from "@/types/apis";

export function usePerformanceEvaluationAdviceBehavior() {
  const [form] = Form.useForm<EvaluationAdviceFiledType>();

  const submitMutaion = useMutation({
    mutationFn: (data: UpdatePerformanceEvaluationAdviceSchema) =>
      updatePerformanceEvaluationAdvice(data),
  });

  const submitAdvice = submitMutaion.mutate;

  return {
    form,
    submitAdvice,
  };
}
